import { useTranslation } from "react-i18next";

import { useModalContext } from "../../../../../../../_metronic/elements/Modal";

const PrescriptionModalHeader = ({
  descriptionKey = null,
  disabled = false,
  isMobile,
  titleKey,
}) => {
  const modal = useModalContext();
  const { t } = useTranslation();

  return (
    <div className={`modal-header prescription-modal__header ${isMobile ? "prescription-modal__header--mobile" : ""}`.trim()}>
      <div className="prescription-modal__title-group">
        <h5 className="modal-title">{t(titleKey)}</h5>
        {isMobile && descriptionKey && (
          <p className="prescription-modal__description">{t(descriptionKey)}</p>
        )}
      </div>
      <button
        type="button"
        className="btn btn-icon btn-sm btn-active-light-primary prescription-modal__close-button"
        onClick={() => modal.hideModal()}
        disabled={disabled}
        aria-label={t("common:actions.close", { defaultValue: "Cerrar" })}
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  );
};

export default PrescriptionModalHeader;
